import { S, Icon } from '../regureStyles';

const Stats = ({ stats }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 }}>
      {stats.map((s, i) => (
        <div key={i} style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 10, padding: '18px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: 26, fontWeight: 700, color: s.color }}>{s.value}</div>
          <div style={{ fontSize: 12, color: S.textMuted, marginTop: 4 }}>{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default Stats;
